import { AlertCircle } from 'lucide-react'
import CommonModal from '../common/CommonModal'
import ActionButton from '../common/ActionButton'

const ErrorModal = ({ open, handleSelectLocationManually }: any) => {
  return (
    <CommonModal open={open}>
      <div>
        <AlertCircle size={48} className="text-danger-500 mx-auto mb-6 sm:mt-4" />
        <h2 className="text-heading-sm mb-2 text-center">
          Location not serviceable
        </h2>
        <p className="text-label-xs text-gray-700 text-center mb-8 w-4/5 mx-auto">
          We are not available at this location at the moment. Please try
          searching city manually
        </p>
        <ActionButton variant="secondary"
          title="Select location manually"
          className="flex mx-auto w-full text-label-lg font-semibold rounded-md"
          onClick={handleSelectLocationManually}
        />
      </div>
    </CommonModal>
  )
}

export default ErrorModal
